import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { withRouter } from 'react-router-dom';
import { useCallback, useContext, useEffect, useState } from 'react';
import { ModalNextContext } from '@jutro/components';

import {
    ViewModelForm,
    ViewModelServiceContext,
    withViewModelService
} from '@xengage/gw-portals-viewmodel-react';
import { BreakpointTrackerContext } from '@jutro/layout';
import { GooglePlacesLookupComponent } from 'cpmi-capability-googleplaces-react';
import { LoaderExt } from 'gw-components-platform-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import _ from 'lodash';
import { useValidation } from '@xengage/gw-portals-validation-react';
import CertificateService from '../../../../../common/capabilities/cpmi-capability-certificate/services/CertificateService';
import messages from './CreateCertificatePage.messages';
import metadata from './CreateCertificatePage.metadata.json5';
import styles from './CreateCertificatePage.module.scss';
import usecpmiAnalytics from '../../../hooks/usecpmiAnalytics'
import useGoogleAnalytics from '../../../hooks/useGoogleAnalytics';



import { CheckboxGroupField } from '@jutro/legacy/components';



function CreateCertificatePage(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const {
        id,
        history: {
            location: {
                state
            },
        },history
    } = props;
    const ModalNext=useContext(ModalNextContext);
    const { authHeader } = useAuthentication();
    const [certPolicyPeriodSummary, setCertPolicyPeriodSummary] = useState(
        props.location.state.data
    );
    const { isComponentValid, registerComponentValidation } = useValidation('CreateCertificatePage');

    const viewModelService = useContext(ViewModelServiceContext);

    const certviewmodel = viewModelService.create(
        { "addendum": "",
        "addressOnBack": false,
        "certificateId": null,
        "certificateNumber": null,
        "classCodes": [],  //["5183", "8810"]
        "creationDate": null,
        "deleted": false,
        "description": "", //"5183 - PLUMBING N.O.C. JOB & SHOP\n8810 - CLERICAL OFFICE EMPLOYEES-N.O.C."
        "displayName": "", //"Dennis L Kotterman Plumbing Inc"   Named Insured Chosen
        "effectiveDate": "", //"2014-04-01T07:00:00Z"
        "endeavorToCancel": false,
        "expirationDate": "", //"2015-04-01T07:00:00Z"
        "holder": {
            "address": {
                "addressLine1": "", 
                "addressLine2": "",
                "city": "", // "Prescott"
                "county": "",
                "state": "", // "AZ"
                "postalCode": "", //"86305"
                "country" : "US"
            },
            "careOfName": "",
            "createdDate": "", //"2014-05-06T16:14:29Z"
            "email": "",
            "holderId": null, //7055932
            "modifiedDate": "", //2014-05-06T16:14:29Z
            "name": "", // "Yavapai County Public Works"
            "policyPeriodId": "" // "pcprod:102"
        },
        "holderId": null, // 7055932
        "hostSystem": "GW",
        "jobId": "",
        "location": "", //Various AZ Locations
        "modifiedDate": null, //"2014-05-06T16:14:58Z"
        "offDutyOfficer": false,
        "periodId": "", //"pcprod:102"
        "policyNumber": null, //"1000002"
        "renew": false,
        "revisionNumber": null, //4
        "showInCareOf": false,
        "subWaiver": false,
        "subWaiverFull": false,
        "subWaiverSched": false},
        'pc',
        'edge.capabilities.cpmi.certificate.dto.CertTemplateDto'
    );
    // const certviewmodel = viewModelService.create(
    //     {},
    //     'pc',
    //     'edge.capabilities.cpmi.certificate.dto.CertTemplateDto'
    // );
    const [createCertificateVM, setCreateCertificateVM] = useState(
        certviewmodel
    );
    const [certData, setCertData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [toggleValue, setToggleValue] = useState(false)
    const [trackPageView] = usecpmiAnalytics();
    const [trackGAPageView] = useGoogleAnalytics();


    useEffect(() => {
        registerComponentValidation(() => {
            return createCertificateVM.holder.address.aspects.valid && createCertificateVM.holder.address.aspects.subtreeValid;
        });
    }, [createCertificateVM.holder.address.aspects.subtreeValid, createCertificateVM.holder.address.aspects.valid, registerComponentValidation]);

    useEffect(() => {
        trackPageView("Create Certificate","/certificate/create")
    },[])

    useEffect(() => {
        trackGAPageView("/certificate/create","Create Certificate")
    },[])

    const writeValue = useCallback(
        (value, path) => {
            const newCreateCertificateVM = viewModelService.clone(createCertificateVM);
            _.set(newCreateCertificateVM, path, value);
            setCreateCertificateVM(newCreateCertificateVM);
        },
        [createCertificateVM, viewModelService]
    );

    const renderOffdutyOfficer = useCallback((value) => {
        value === 'yes' ? setToggleValue(true) : setToggleValue(false);
        publish('JUTRO_TOPICS.BUTTON_CLICKED', 'JUTRO_TOPICS.VALUE_CHANGED', 'JUTRO_TOPICS.FIELD_BLUR', {
            path: '/certificate/create/policyNo,pcrint:id',
            title: 'Create Certificate of Insurance'
        });
    },[])

    const getClassCodes = useCallback(
        (policyperiod) => {
            return Object.entries(policyperiod.classCodesByState).map(
                ([key, value]) => {
                    let classcodes=""
                    return (
                        <>
                            <CheckboxGroupField
                                availableValues={
                                    value.map((item) => {
                                        classcodes=item.compositeKey
                                        return {
                                            code:item.compositeKey,
                                            name:`${item.code} - ${item.shortDesc}`
                                        }
                                    })
                                }
                                id="checkbox-group-field"
                                path="classCodes"
                                label={key}
                                labelClassName={styles.labelNmae}
                                onBlur={function noRefCheck() {}}
                                onFocus={function noRefCheck() {}}
                                onValidationChange={function noRefCheck() {}}
                                onValueChange={writeValue}
                                value={createCertificateVM.classCodes.value || createCertificateVM.classCodes}
                                className={styles.labelSeperator}
                            />
                        </>
                    );
                }
            );
        },
        [createCertificateVM.classCodes, writeValue]
    );

    const cancelChange = useCallback(() => {
        ModalNext.showConfirm({
            title: messages.cancelChangeTitle,
            message: messages.cancelChangeMessage,
            status: 'info',
            icon: 'mi-error-outline',
            confirmButtonText: commonMessages.yesModel,
            cancelButtonText: commonMessages.noModel,
        }).then((results) => {
            if (results === 'confirm') {
                history.go(-1);
            }
        }, _.noop);
    }, [ModalNext]);

    const saveCertificate = useCallback(() => {
        _.set(createCertificateVM,'policyNumber',props.match.params.selectedPolicy)
        _.set(createCertificateVM,'periodId',props.match.params.termPublicId)
        
        setIsLoading(true);
        CertificateService.createCertificate([createCertificateVM.value], authHeader)
            .then((res) => {

                // return history.push(`/certificate/${props.match.params.selectedPolicy}/${props.match.params.termPublicId}/list`)
                return history.push({
                    pathname: `/certificate/${props.match.params.selectedPolicy}/${props.match.params.termPublicId}/list`,
                    search:`?created`,

                });

            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [CertificateService,createCertificateVM,authHeader,setIsLoading]);

    

    const certificateData = createCertificateVM.value;


    const getInsuredAvailableValues = () => {
        const namedInsuredArray = [];

        certPolicyPeriodSummary.namedInsureds.map((item) => {
            namedInsuredArray.push({
                code: item,
                name: item,
            });
        });

        return namedInsuredArray;
    };

    const setDisabled = useCallback(()=> {
        if(!_.isEmpty(_.get(createCertificateVM.value,'holder.name')) &&
        !_.isEmpty(_.get(createCertificateVM.value,'displayName')) && 
        isComponentValid && 
        _.get(createCertificateVM.value,'classCodes').length>0
        )
        {
            return false;
        }
        return true;
    },[createCertificateVM.value, isComponentValid])

    const overrides = {
        '@field': {
            labelPosition: breakpoint === 'tablet' ? 'top' : 'left',
            phoneWide: {
                labelPosition: 'top'
            }
        },
        policyNum: {
            value: certPolicyPeriodSummary.policyPeriodDto.policyNumber,
        },
        WaiverofSubrogation:{
            visible:certPolicyPeriodSummary.waiverOfSubAllowed
        },
        namedinsured: {
            availableValues: getInsuredAvailableValues(),
        },
        classCodes: {
            content: getClassCodes(certPolicyPeriodSummary),
        },
        CreateCertficateSave: {
            disabled: setDisabled()
        },
        COIgoogleplaces: {
            visible: true,
        },

        offdutypoliceofficer:{
            showRequired:false
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            googleplaces: GooglePlacesLookupComponent,
        },
        resolveCallbackMap: {
            cancelChange,
            writeValue,
            renderOffdutyOfficer,
            saveCertificate
        },
    };

    if (isLoading) {
        return <LoaderExt loaded={!isLoading} />;
    }

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={createCertificateVM}
            overrideProps={overrides}
            onValueChange={writeValue}           
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
          
        />
    );
}

export default withRouter(withViewModelService(CreateCertificatePage));